import React, { useCallback, useRef, useState, useEffect } from 'react'
import { SLowcodeList, STableActions, SActionBtn } from 'shj-components'
import { Button, Col, DatePicker, Row, Table, Tabs, Select, Badge } from 'antd'
import { get } from 'lodash-es'
import config from './config'
import styles from '../../index.module.less'
import { useSetState } from 'ahooks'
import { getWorkerOrderDetail } from '@/services/homeService'
import { log } from 'console'
import { getUser } from '@/common/utils'
import { navigatePage } from '@/common/utils'
import { useNavigate } from 'react-router-dom'

import { BackLog } from './components/BackLog'

import WorkDetail from './components/workDetail'

const { TabPane } = Tabs
const detail = (props: any) => {
  const listRef = useRef<any>()
  const { param } = props

  const [details, setDetails] = useState({})

  useEffect(() => {
    initFn()
    return () => {}
  }, [])

  const initFn = () => {

    getWorkerOrderDetail(param).then(res => {
      let data = res
      data.orderList.classifyStatus = keysToList(data?.orderList?.classifyStatusList, 'desc')
      data.orderList.firstLevelCopyPerson = keysToList(
        data?.orderList.firstLevelCopyPerson && JSON.parse(data?.orderList?.firstLevelCopyPerson),
        'name'
      )
      data.orderList.secondLevelCopyPerson = keysToList(
        data?.orderList.secondLevelCopyPerson && JSON.parse(data?.orderList?.secondLevelCopyPerson),
        'name'
      )
      data.orderList.threeLevelCopyPerson = keysToList(
        data?.orderList.threeLevelCopyPerson && JSON.parse(data?.orderList?.threeLevelCopyPerson),
        'name'
      )
      data.issueList.files = data?.issueList.files ? JSON.parse(data.issueList.files) : []

      setDetails(res)
    })
  }

  const keysToList = (arrList, arrKey) => {
    if (!Array.isArray(arrList)) return
    let list: any[] = []
    arrList.map(item => {
      list.push(item[arrKey])
    })
    return list || []
  }

  return (
    <div>
      <Tabs defaultActiveKey="1" onChange={() => {}} tabBarStyle={{ paddingLeft: '16px' }}>
        <TabPane tab="基本信息" key="1">
          <WorkDetail
            details={{
              ...details,
            }}
          />
        </TabPane>

        <TabPane tab="退回记录" key="2">
          <BackLog detailsInfo={details.orderList}></BackLog>
        </TabPane>
      </Tabs>
    </div>
  )
}
export default detail
